/**
 * @license
 * Copyright CCV. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
 
export const environment = {
  production: false,
  //apiBaseUrl: 'https://localhost:7063/',
  apiBaseUrl: 'https://dmskqlu1h0.execute-api.ap-northeast-1.amazonaws.com/dev/',
  attachmentUrl: 'https://dlb4geuyglbfp.cloudfront.net/',
  supportEmailDomain: 'care-connect.vn',
  tokenUrl: 'https://api.dev2.token.ck1lab.net',
  cKPassWebappUrl: 'http://dev2.pass.ck1lab.net/',
  excludeOnProd: false,
};
